import React, { useRef } from "react";
import styled from "styled-components";
import BaseSection from "../../BaseSection";
import Responsable from "../../../Responsable";
import ScrollOverlayHero from "../scrollOverays/ScrollOverlayHero";

interface HomeSection01Props { }

const HomeSection01: React.FC<HomeSection01Props> = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const windowHeight = useRef<number>(window.innerHeight);

  return (
    <Base ref={containerRef} fullWidth fullHeight>
      <Responsable
        backgroundColor="black"
        pc={
          <ScrollOverlayHero
            height={`${windowHeight}px`}
            screenType="PC"
          />
        }
        tablet={
          <ScrollOverlayHero
            height={`${windowHeight}px`}
            screenType="TABLET"
          />
        }
        mobile={
          <ScrollOverlayHero
            height={`${windowHeight}px`}
            screenType="MOBILE"
          />
        }
      />
    </Base>
  );
};

export default HomeSection01;
const Base = styled(BaseSection)`
  position: relative;
  min-height: 600px;
  background: #111;
`;